// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const DigitalExperienceSignetIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon
      data-iconname="DigitalExperienceSignetIcon"
      ref={forwardedRef}
      {...props}
    >
      <path d="M6.751 8.475a5.22 5.22 0 0 1 1.89-4.027c.155-.129.061-.381-.14-.381h-2.06a4.112 4.112 0 0 0 0 8.223h1.225a.32.32 0 0 0 .25-.523 5.2 5.2 0 0 1-1.165-3.292" />
      <path d="M10.29 10.41a3.1 3.1 0 0 1-.733-.664.19.19 0 0 0-.21-.06l-1.377.44a.192.192 0 0 0-.117.262 4.47 4.47 0 0 0 1.584 1.877.192.192 0 0 0 .285-.086l.641-1.537a.19.19 0 0 0-.072-.233" />
      <path d="M8.79 7.582 7.842 7.193a.152.152 0 0 0-.203.1 4.45 4.45 0 0 0-.03 2.404.152.152 0 0 0 .216.094l1.21-.626a.15.15 0 0 0 .072-.188 3.1 3.1 0 0 1-.224-1.25.15.15 0 0 0-.093-.145" />
      <path d="M7.892 6.63A.143.143 0 0 0 7.99 6.832l.857.192a.14.14 0 0 0 .167-.095A3.1 3.1 0 0 1 9.807 5.62a.14.14 0 0 0 .028-.17l-.27-.513a.144.144 0 0 0-.21-.049A4.5 4.5 0 0 0 7.891 6.63" />
      <path d="M14.638 6.291a3.06 3.06 0 0 1 .406 1.45l.001.014a3 3 0 0 1-.182 1.104l-.004.014a3 3 0 0 1-.413.774.14.14 0 0 0 .02.189l1.12 1.018a.144.144 0 0 0 .221-.035 4.47 4.47 0 0 0 .616-2.401l-.002-.014a4.5 4.5 0 0 0-.1-.809l-.003-.018-.01-.041-.016-.065-.02-.082-.042-.146-.006-.018a4.45 4.45 0 0 0-.897-1.614.12.12 0 0 0-.178-.001l-.496.538a.12.12 0 0 0-.015.142z" />
      <path d="M11.748 4.748a4.3 4.3 0 0 1 1.002.095 3.1 3.1 0 0 1 1.45.86.12.12 0 0 0 .162.013l.492-.38a.12.12 0 0 0 .004-.189 4.5 4.5 0 0 0-2.038-.992h-.008a3 3 0 0 0-.78-.086 4.5 4.5 0 0 0-2.038.444.157.157 0 0 0-.057.237l.278.364a.155.155 0 0 0 .2.042 3.1 3.1 0 0 1 1.333-.408" />
      <path d="m17.613 15.747-5.65-7.985a.305.305 0 0 0-.552.155l-.69 9.757a.304.304 0 0 0 .534.22l2.32-2.675a.31.31 0 0 1 .324-.091l3.372 1.085a.305.305 0 0 0 .342-.466" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const DigitalExperienceSignetIcon = /* @__PURE__ */ Object.assign(
  DigitalExperienceSignetIconComponent,
  { displayName: 'DigitalExperienceSignetIcon' },
);
